export enum RolesType {
    'ADMIN' = 'Admin',
    'CREATOR' = 'Créateur  0.1',
    'MULTI' = 'Créateur  0.2 Multicompte',
    'SERVICE_PROVIDER' = 'Prestataire'
}
